{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-750000",
  "sheetId": "NotesRelatedPartyTransactions",
  "label": "[750000] Notes - Related Party Transactions",
  "description": "Disclosure of related party relationships, transactions, and outstanding balances (MFRS)",
  "columnSumValidations": [
    {
      "subTotalColumnQname": "Total",
      "componentColumnQnames": [
        "ifrs-full:ParentMember",
        "ifrs-full:JointControlOrSignificantInfluenceMember",
        "ifrs-full:SubsidiariesMember",
        "ifrs-full:AssociatesMember",
        "ifrs-full:JointVenturesWhereEntityIsVenturerMember",
        "ifrs-full:KeyManagementPersonnelOfEntityOrParentMember",
        "ifrs-full:OtherRelatedPartiesMember"
      ],
      "subTotalLabel": "Total related party",
      "componentLabels": [
        "Parent",
        "Entities with joint control or significant influence",
        "Subsidiaries",
        "Associates",
        "Joint ventures where entity is venturer",
        "Key management personnel",
        "Other related party"
      ],
      "appliesToRowQnames": [
        "ssmt-mfrs:RelatedPartyTransactionsContributionToFund",
        "ssmt-mfrs:RelatedPartyTransactionsDisposalOfSubsidiaries",
        "ssmt-mfrs:DividendIncomeRelatedPartyTransactions",
        "ssmt-mfrs:InterestIncomeRelatedPartyTransactions",
        "ssmt-mfrs:RelatedPartyTransactionsIssueOfSharesForExchangeableBonds",
        "ifrs-full:KeyManagementPersonnelCompensation",
        "ssmt-mfrs:RelatedPartyTransactionsKeyManagementPersonnelServiceFees",
        "ssmt-mfrs:RelatedPartyTransactionsManagementFees",
        "ssmt-mfrs:OtherExpensesRecognisedForTransactionsWithRelatedParties",
        "ssmt-mfrs:RelatedPartyTransactionsOtherKeyManagementPersonnel",
        "ssmt-mfrs:OtherRevenueRecognisedForTransactionsWithRelatedParties",
        "ssmt-mfrs:RelatedPartyTransactionsEducationAndStaffTrainingServices",
        "ssmt-mfrs:RelatedPartyTransactionsLeasingAndHirePurchaseFacilities",
        "ifrs-full:PurchasesOfGoodsRelatedPartyTransactions",
        "ifrs-full:PurchasesOfPropertyAndOtherAssetsRelatedPartyTransactions",
        "ssmt-mfrs:RentalExpensesRelatedPartyTransactions",
        "ssmt-mfrs:RelatedPartyTransactionsRentalIncome",
        "ifrs-full:RevenueFromSaleOfGoodsRelatedPartyTransactions",
        "ifrs-full:RevenueFromRenderingOfServicesRelatedPartyTransactions",
        "ssmt-mfrs:RelatedPartyTransactionsRoyaltyExpenses",
        "ssmt-mfrs:RelatedPartyTransactionsRoyaltyIncome",
        "ifrs-full:SalesOfPropertyAndOtherAssetsRelatedPartyTransactions",
        "ifrs-full:ServicesReceivedRelatedPartyTransactions",
        "ssmt-mfrs:RelatedPartyTransactionsShareOptionRecharged",
        "ssmt-mfrs:RelatedPartyTransactionsShareBasedPaymentTransactions",
        "ssmt-mfrs:RelatedPartyTransactionsSupplementaryPaymentsAndSignatureBonus",
        "ssmt-mfrs:RelatedPartyTransactionsTransactionsWithShareholdersAndGovernments",
        "ssmt-mfrs:OtherTransactionsWithRelatedParties",
        "ifrs-full:AmountsPayableRelatedPartyTransactions",
        "ifrs-full:AmountsReceivableRelatedPartyTransactions",
        "ssmt-mfrs:OtherBalancesWithRelatedParties"
      ]
    }
  ],
  "controls": [
    {
      "qname": "ssmt-mfrs:DisclosureOnRelatedPartyTransactionsAbstract",
      "label": "Disclosure on related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ifrs-full:DisclosureOfTransactionsBetweenRelatedPartiesExplanatory",
      "label": "Disclosure of transactions between related parties",
      "type": "TextBlock",
      "ui": {
        "control": "richtext",
        "rows": 8
      },
      "required": true,
      "validators": [{ "name": "required" }],
      "error": {
        "required": "This is a mandatory field."
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfTransactionsBetweenRelatedPartiesHeader",
      "label": "Disclosure of transactions between related parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfTransactionsBetweenRelatedPartiesLevel3Header",
      "label": "Disclosure of transactions between related parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 3
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsHeader",
      "label": "Related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsContributionToFund",
      "label": "Contribution to fund",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsDisposalOfSubsidiaries",
      "label": "Disposal of subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:DividendIncomeRelatedPartyTransactions",
      "label": "Dividend income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:InterestIncomeRelatedPartyTransactions",
      "label": "Interest income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsIssueOfSharesForExchangeableBonds",
      "label": "Issue of shares for exchangeable bonds",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:KeyManagementPersonnelCompensation",
      "label": "Key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsKeyManagementPersonnelServiceFees",
      "label": "Key management personnel services fee",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsManagementFees",
      "label": "Management fees",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherExpensesRecognisedForTransactionsWithRelatedParties",
      "label": "Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsOtherKeyManagementPersonnel",
      "label": "Other key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherRevenueRecognisedForTransactionsWithRelatedParties",
      "label": "Other revenue",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsEducationAndStaffTrainingServices",
      "label": "Provision of education and staff training services",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsLeasingAndHirePurchaseFacilities",
      "label": "Provision of leasing and hire purchase facilities",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:PurchasesOfGoodsRelatedPartyTransactions",
      "label": "Purchases of goods",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:PurchasesOfPropertyAndOtherAssetsRelatedPartyTransactions",
      "label": "Purchases of property and other assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RentalExpensesRelatedPartyTransactions",
      "label": "Rental expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsRentalIncome",
      "label": "Rental income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromSaleOfGoodsRelatedPartyTransactions",
      "label": "Revenue from sale of goods",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:RevenueFromRenderingOfServicesRelatedPartyTransactions",
      "label": "Revenue from rendering of services",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsRoyaltyExpenses",
      "label": "Royalty expense",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsRoyaltyIncome",
      "label": "Royalty income",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:SalesOfPropertyAndOtherAssetsRelatedPartyTransactions",
      "label": "Sales of property and other assets",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:ServicesReceivedRelatedPartyTransactions",
      "label": "Services received",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsShareOptionRecharged",
      "label": "Share options recharged",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsShareBasedPaymentTransactions",
      "label": "Share-based payment transactions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsSupplementaryPaymentsAndSignatureBonus",
      "label": "Supplemental payments and signature bonus",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyTransactionsTransactionsWithShareholdersAndGovernments",
      "label": "Transactions with shareholders and governments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherTransactionsWithRelatedParties",
      "label": "Other related parties transaction",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OutstandingBalancesForRelatedPartyTransactionsHeader",
      "label": "Outstanding balances for related party transactions",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 4
      }
    },
    {
      "qname": "ifrs-full:AmountsPayableRelatedPartyTransactions",
      "label": "Amounts payable",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ifrs-full:AmountsReceivableRelatedPartyTransactions",
      "label": "Amounts receivable",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:OtherBalancesWithRelatedParties",
      "label": "Other outstanding balances",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR",
        "tableColumn": true
      }
    },
    {
      "qname": "ssmt-mfrs:RelatedPartyRelationshipsHeader",
      "label": "Related party relationships",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfRelatedPartyRelationships",
      "label": "Description of related party relationships",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 5,
        "placeholder": "Describe the nature of related party relationships"
      }
    },
    {
      "qname": "ssmt-mfrs:ParentAndSubsidiariesHeader",
      "label": "Parent and Subsidiaries",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
      "label": "Are there transactions with parent company?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfTransactionsWithParentCompany",
      "label": "Description of transactions with parent company",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Describe the nature and amounts of transactions"
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfTransactionsWithParentCompany",
      "label": "Amount of transactions with parent company",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OutstandingBalanceWithParentCompany",
      "label": "Outstanding balance with parent company",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithParentCompany",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
      "label": "Are there transactions with subsidiaries?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfTransactionsWithSubsidiaries",
      "label": "Description of transactions with subsidiaries",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfTransactionsWithSubsidiaries",
      "label": "Amount of transactions with subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OutstandingBalanceWithSubsidiaries",
      "label": "Outstanding balance with subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithSubsidiaries",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:AssociatesAndJointVenturesHeader",
      "label": "Associates and Joint Ventures",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithAssociates",
      "label": "Are there transactions with associates?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfTransactionsWithAssociates",
      "label": "Description of transactions with associates",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfTransactionsWithAssociates",
      "label": "Amount of transactions with associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OutstandingBalanceWithAssociates",
      "label": "Outstanding balance with associates",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithAssociates",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
      "label": "Are there transactions with joint ventures?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfTransactionsWithJointVentures",
      "label": "Description of transactions with joint ventures",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Describe the transactions"
      }
    },
    {
      "qname": "ssmt-mfrs:AmountOfTransactionsWithJointVentures",
      "label": "Amount of transactions with joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OutstandingBalanceWithJointVentures",
      "label": "Outstanding balance with joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithJointVentures",
        "conditionalValue": "Yes",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:KeyManagementPersonnelHeader",
      "label": "Key Management Personnel Compensation",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:ShortTermEmployeeBenefitsToKeyManagementPersonnel",
      "label": "Short-term employee benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:PostEmploymentBenefitsToKeyManagementPersonnel",
      "label": "Post-employment benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OtherLongTermBenefitsToKeyManagementPersonnel",
      "label": "Other long-term benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:TerminationBenefitsToKeyManagementPersonnel",
      "label": "Termination benefits",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:ShareBasedPaymentsToKeyManagementPersonnel",
      "label": "Share-based payments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:TotalCompensationToKeyManagementPersonnel",
      "label": "Total compensation to key management personnel",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsRemunerationHeader",
      "label": "Directors' Remuneration",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsFees",
      "label": "Directors' fees",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsSalariesAndBonuses",
      "label": "Directors' salaries and bonuses",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsEPFContributions",
      "label": "Directors' EPF contributions",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:DirectorsOtherEmoluments",
      "label": "Directors' other emoluments",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:TotalDirectorsRemuneration",
      "label": "Total directors' remuneration",
      "type": "MonetaryItemType",
      "ui": {
        "control": "number",
        "placeholder": "Enter amount in MYR"
      }
    },
    {
      "qname": "ssmt-mfrs:OtherRelatedPartiesHeader",
      "label": "Other Related Parties",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithOtherRelatedParties",
      "label": "Are there transactions with other related parties?",
      "type": "YesNoItemType",
      "ui": {
        "control": "dropdown",
        "options": ["Yes", "No"]
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfOtherRelatedPartyTransactions",
      "label": "Description of other related party transactions",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 5,
        "conditionalOn": "ssmt-mfrs:DisclosureOfWhetherThereAreTransactionsWithOtherRelatedParties",
        "conditionalValue": "Yes",
        "placeholder": "Describe transactions with other related parties"
      }
    },
    {
      "qname": "ssmt-mfrs:AdditionalDisclosuresHeader",
      "label": "Additional Disclosures",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": 2
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfTermsAndConditionsOfRelatedPartyTransactions",
      "label": "Terms and conditions of related party transactions",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "placeholder": "Describe terms, conditions, and whether transactions are at arm's length"
      }
    },
    {
      "qname": "ssmt-mfrs:DescriptionOfGuaranteesProvidedOrReceived",
      "label": "Guarantees provided or received",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 3,
        "placeholder": "Describe any guarantees with related parties"
      }
    },
    {
      "qname": "ssmt-mfrs:DisclosureOfWriteOffsOrAllowances",
      "label": "Write-offs or allowances for related party balances",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 3,
        "placeholder": "Describe any write-offs or allowances"
      }
    }
  ]
}
